// extracted by mini-css-extract-plugin
export default {"button":"ItemAction_button__9xA3P","icon":"ItemAction_icon__z45nC","desc":"ItemAction_desc__rfJnR"};